<template>
    <div>
        <v-img
            v-if="location.id == value.id"
            gradient="to top right, rgba(123, 177, 224, 0.8), rgba(123, 177, 224, 0.8)"
            @click="$emit('input', location)"
            style="cursor: pointer"
            src="/grandview-exterior.webp"
            height="142px"
            class="align-end soli-round mb-3 white--text"
        >
            <v-card-title class="font-weight-bold">{{
                location.name
            }}</v-card-title>
            <v-card-subtitle class="py-0">{{
                location.address
            }}</v-card-subtitle>
            <v-card-subtitle class="py-0">{{ location.email }}</v-card-subtitle>
            <v-card-subtitle class="pt-0">{{ location.phone }}</v-card-subtitle>
            <v-icon
                v-if="icon"
                color="white"
                class="px-5"
                style="position: absolute; top: 33%; right: 0px"
                >{{ icon }}</v-icon
            ></v-img
        >
        <v-expand-transition
            ><div v-show="value.id == location.id">
                <v-container v-if="location.CM" class="flex py-0">
                    <v-list-item-avatar size="64" class="shadow-blue">
                        <v-img :src="location.CM?.profile_photo_url"></v-img>
                    </v-list-item-avatar>
                    <div class="align-self-center">
                        <small>Community Manager</small>
                        <div>{{ location.CM.name }}</div>
                    </div>
                </v-container>

                <v-card-actions class="justify-space-around mb-5"
                    ><v-btn icon :href="'tel:' + location.phone"
                        ><v-icon color="dark">phone</v-icon>
                        <small
                            class="mt-1 panel-text"
                            style="text-transform: none"
                            >Call</small
                        > </v-btn
                    ><v-btn icon :href="'sms:' + location.phone"
                        ><v-icon color="dark">sms</v-icon>
                        <small
                            class="mt-1 panel-text"
                            style="text-transform: none"
                            >Text</small
                        > </v-btn
                    ><v-btn icon :href="'mailto:' + location.email"
                        ><v-icon color="dark">email</v-icon>
                        <small
                            class="mt-1 panel-text"
                            style="text-transform: none"
                            >Email</small
                        >
                    </v-btn></v-card-actions
                >
            </div></v-expand-transition
        >
    </div>
</template>

<script>
export default {
    props: {
        location: {
            type: Object,
            default: () => {},
        },
        value: {
            type: Object,
            default: () => {},
        },
        icon: {
            type: [Boolean, String],
            default: "expand_less",
        },
    },
};
</script>

<style></style>
